import { Spinner as Loader } from '@nike/eds'

import styles from './spinner.styl'

export const Spinner = (): JSX.Element => <Loader size='large' className={styles.pageSpinner} />
